var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicesSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 78,
    viewBox: "0 0 80 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 39,
    rx: 39.5,
    ry: 39,
    fill: "#F4E5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5044 25.9556H43.2402C42.4446 25.9556 41.6748 26.1889 41.0133 26.6299L39.9944 27.3086L38.9754 26.6299C38.3139 26.1889 37.5441 25.9556 36.7485 25.9556H36.4843C34.2703 25.9556 32.4686 27.7573 32.4686 29.9712C32.4686 30.9645 32.8343 31.9188 33.4997 32.6578L39.9944 39.8745L46.489 32.6578C47.1545 31.9196 47.5201 30.9645 47.5201 29.9712C47.5201 27.7573 45.7184 25.9556 43.5044 25.9556ZM45.3708 31.6509L39.9944 37.6241L34.6179 31.6502C34.2027 31.189 33.9738 30.593 33.9738 29.9712C33.9738 28.5874 35.1004 27.4607 36.4843 27.4607H36.7485C37.2461 27.4607 37.7275 27.6066 38.1416 27.8822L39.9944 29.118L41.8471 27.8822C42.2613 27.6066 42.7426 27.4607 43.2402 27.4607H43.5044C44.8883 27.4607 46.0149 28.5874 46.0149 29.9712C46.0149 30.593 45.786 31.189 45.3708 31.6509Z",
    fill: "#7F00E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7367 57.5635H42.2521V59.0686H37.7367V57.5635Z",
    fill: "#7F00E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5305 53.0482V22.9453H29.4585V53.0482H50.5305ZM30.9636 24.4505H49.0254V51.5431H30.9636V24.4505Z",
    fill: "#7F00E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4686 48.5322H33.9738V50.0374H32.4686V48.5322Z",
    fill: "#7F00E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.479 48.5322H47.5202V50.0374H35.479V48.5322Z",
    fill: "#7F00E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4688 45.5225H47.5202V47.0276H32.4688V45.5225Z",
    fill: "#7F00E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5099 42.5122H47.5202V44.0174H44.5099V42.5122Z",
    fill: "#7F00E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4686 42.5122H43.0047V44.0174H32.4686V42.5122Z",
    fill: "#7F00E2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4511 18.3638C53.0764 16.6813 51.5716 15.4194 49.7779 15.4194H30.211C28.1363 15.4194 26.4481 17.1076 26.4481 19.1823V58.3161C26.4481 60.3908 28.1363 62.079 30.211 62.079H49.7779C51.5716 62.079 53.0764 60.8171 53.4511 59.1346V18.3638ZM49.7779 16.9246H30.211C28.9664 16.9246 27.9533 17.9377 27.9533 19.1823V19.9349H52.0356V19.1823C52.0356 17.9377 51.0225 16.9246 49.7779 16.9246ZM52.0356 54.5532V21.44H27.9533V54.5532H52.0356ZM30.211 60.5738H49.7779C51.0225 60.5738 52.0356 59.5607 52.0356 58.3161V56.0584H27.9533V58.3161C27.9533 59.5607 28.9664 60.5738 30.211 60.5738Z",
    fill: "#7F00E2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesSupport);
export default __webpack_public_path__ + "static/media/servicesSupport.a487c68f645ff5053b9b3dfb6761b577.svg";
export { ForwardRef as ReactComponent };